import { Paragraph } from "@/components/ui/typography/Paragraph";
import { ParagraphBold } from "@/components/ui/typography/ParagraphBold";

interface SidebarItemProps {
  Icon: React.ComponentType<React.SVGProps<SVGSVGElement>>;
  label: string;
  disabled?: boolean;
  active?: boolean;
  onClick?: () => void;
}

export const SidebarItem: React.FC<SidebarItemProps> = ({
  Icon,
  label,
  disabled = false,
  active = false,
  onClick,
}) => {
  const textAndIconColor = disabled ? "text-neutral-700" : "text-black";

  const handleClick = () => {
    if (!disabled && onClick) {
      onClick();
    }
  };

  return (
    <button
      onClick={handleClick}
      className={`flex items-center space-x-2 p-2 rounded-md min-w-full ${!disabled ? "cursor-pointer hover:bg-neutral-100" : "cursor-not-allowed hover:bg-beige"} ${
        active ? "bg-neutral-100" : ""
      }`}
    >
      <Icon className={textAndIconColor} />
      {active ? (
        <ParagraphBold>{label}</ParagraphBold>
      ) : (
        <Paragraph color={textAndIconColor}>{label}</Paragraph>
      )}
    </button>
  );
};
